module.exports = __webpack_public_path__ + "static/08fbc331.06.gif";